.customLogo {
  object-fit: contain;
  display: block;
}
